import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import "../SignupPages/SignupCommon.css";
import "../SignupPages/Signup6.css";
import image from "../../assets/images/than_and_now.png";
import DocImage from "../../assets/images/CLAYA_COL2.png";
import NationalIns from "../../assets/images/nih-logo-black1.png";
import Stanford from "../../assets/images/stanford-medicine-logo1.png";
import HarvardUni from "../../assets/images/harvard-university-logo1.png";
import WebMD from "../../assets/images/webmd-logo1.png";
import CustomStepper from "./Stepper";
const NewSignupPage8: React.FC = () => {
  const navigate = useNavigate();

  const location = useLocation();

  const safeNavigate = (path: string) => {
    if (location.pathname !== path) {
      navigate(path, { replace: true });
    }
  };

  useEffect(() => {
    const step7Completed = localStorage.getItem("step-7-completed");
    if (step7Completed) {
      safeNavigate("/getting-started/step-8");
    } else {
      safeNavigate("/getting-started/step-7");
    }
  }, []);
  

  const handleBack = () => {
    navigate("/getting-started/step-7");
  };

  const handleNext = () => {
    localStorage.setItem("step-8-completed", "true");
    navigate("/getting-started/step-9");
  };
  return (
    <PageWrapper onBack={handleBack}>
      <div className="signup-page-container container">
        <CustomStepper activeStep={1} onBack={handleBack} />
        <div className="signup-content">
          <h1 className="signup-content-header" style={{ color: "#000" }}>
            “I lost 40 pounds, lowered my blood pressure, and finally have the
            energy to keep up with my kids. At 43, I feel healthier and stronger
            than ever!”
          </h1>
          <div
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              marginTop: "30px",
            }}
          >
            <img
              src={image}
              alt="Before and After"
              className="beforeAndAfterImage"
              style={{
                width: "100%",
                height: "auto",
              }}
            />

            <div
              style={{
                position: "absolute",
                top: "0",
                left: "55%",
                transform: "translateX(-60%)",
                width: "8px",
                height: "100%",
                backgroundColor: "white",
              }}
            ></div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "22px",
            }}
          ></div>
          <div>
            <span
              className="client-info"
              style={{ textAlign: "left", padding: "0px" }}
            >
              Karli dropped her blood pressure and upped her confidence in only
              5 months
            </span>
          </div>

          <div
            className="medical-institution-container"
            style={{ marginTop: "20px" }}
          >
            <p
              className="signup-content-header"
              style={{ textAlign: "center" }}
            >
              Backed by Leading Medical Institutions
            </p>
            <div className="main-image">
              <img src={DocImage} alt="Claya Doctor" />
            </div>
            <div className="university-images">
              <div className="national-inst" style={{ background: "#FCBAA9" }}>
                <img
                  src={NationalIns}
                  alt="Weight loss"
                  className="university-img"
                />
              </div>
              <div className="national-inst" style={{ background: "#F7EEAB" }}>
                <img
                  src={Stanford}
                  alt="Weight loss"
                  className="university-img"
                />
              </div>
            </div>
            <div className="university-images">
              <div className="national-inst" style={{ background: "#DDC6F0" }}>
                <img
                  src={HarvardUni}
                  alt="Weight loss"
                  className="university-img"
                />
              </div>
              <div className="national-inst" style={{ background: "#BFDDF1" }}>
                <img src={WebMD} alt="Weight loss" className="university-img" />
              </div>
            </div>
            <div className="prescription-content" style={{ textAlign: "left" }}>
              <span className="medication-content medic-content-bold">
                The medications that our doctors prescribe
              </span>
              <span className="medication-content medic-content-light">
                {" "}
                are recommended by Harvard, Mayo Clinic, WebMD & the National
                Institutes of Health.
              </span>
            </div>
          </div>
          <button
            onClick={handleNext}
            className="next-btn sticky-btn"
            style={{ marginTop: "20px" }}
          >
            Continue →
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default NewSignupPage8;
